import { Environment } from '../app/models/environment'

export const environment: Environment = {
  production: true,
  name: 'dev',
  baseUrl: 'https://locmat-dev.leon-grosse.fr/locmat-api-rest',
  mediaBaseUrl: 'https://locmat-dev.leon-grosse.fr/locmat-api-rest',
  awsLambdaParam: 'dev-nonprodlocmat',
  oauth: {
    clientId: '591mek1e2fb2ce74h1u4uohl5e',
    loginUrl: 'https://lguserpoollocmatdev.auth.eu-west-3.amazoncognito.com/oauth2/authorize',
    issuer: 'https://cognito-idp.eu-west-3.amazonaws.com/eu-west-3_C1OR1yHlZ',
    logoutUrl: 'https://lguserpoollocmatdev.auth.eu-west-3.amazoncognito.com/logout',
    tokenEndpoint: 'https://lguserpoollocmatdev.auth.eu-west-3.amazoncognito.com/oauth2/token',
    userInfoEndpoint: 'https://lguserpoollocmatdev.auth.eu-west-3.amazoncognito.com/oauth2/userInfo',
    jwks: {
      keys: [
        {
          alg: 'RS256',
          e: 'AQAB',
          kid: 'uBGumS18AlyTjv7Y/JOas2KLNpu+D0ca3GY/dMKY8nc=',
          kty: 'RSA',
          n: '19e5XjJeiEl94ONKRzOs0qFSWjMiQ5Rkh176d0rUnDN3VNJxmt0-D39PTUOjVXSJy3YghSYhCtNaI5t2pM_dEaX-W9sh2Z_bgG4jSv6R9hRA1kEONkr7q0uEajO5vUI9TKtEzZ32MCqwbjVjPad7q3a52yAQIaU2IRzkuN6sGikpZxcJcuCkKfQl6jzCFy2L4QCCLSNIRg8BayHAAj1bG0GqGWcZpZroma0YMUlVKnKwvqi9XBKC4BkGJOmyGOZcdWqugCOclnqduZRPBCZCSzXs_P_tgeX79pcZ2ySeWLGCqxJut3GcbxrAGwJhwvrz5wIjs5PoS8uHfeKyqAcPBw',
          use: 'sig',
        },
        {
          alg: 'RS256',
          e: 'AQAB',
          kid: 's4VqHji7OuPJHiHOrv/qx4BO8SGL0t2c3me72j8666g=',
          kty: 'RSA',
          n: 'o25zezBuK4fiSqn4yOaBIvFlsMGl5X1TAUWefCicrQWybnbGKycfcXF3XNLPJ0HyHWl-6WQ5SkEDIxTq-VqWzWo1kIMcWFDWiILqI08wdYbzuxbGbegLFvlPlPxHFXQwZxFzHb9-5fc8qFeKbqf1nILw0UV4y4VKNjffgM-8BwLrf98dd6hc9vACN3o1ottemPgJZgJ3Xo5hFOnO4reaIkZCV3w0En0ZEJt8lGeRwu_nYvpi9iMv0rSW1zWT4cCZwutBn1Ft1dyZL2cxmbUtVQqzhO_15GKSptVmVr-nM13teDhBkYBOXDMgBqLTKOcj6GpWeC2T9Bi0fjnit7y6CQ',
          use: 'sig',
        },
      ],
    },
  },
}
